import type { AccountClassification as AccountClassificationModel } from '@/adapters/catalogv1.g';

export function extractAccountClassification(
  model: AccountClassificationModel
) {
  return {
    id: model._metadata?.distinct_id ?? '',
    accountRef: model.account_ref ?? '',
    classificationRef: model.classification_ref ?? '',
    confidence: model.confidence,
    tenantId: model._metadata?.tenant_id,
    connectorId: model._metadata?.segment_id,
  };
}

export type CatalogAccountClassification = ReturnType<
  typeof extractAccountClassification
>;
